(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--comparison-table"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--comparison-table');
if(!el)return;
if(!window.stack?.isChecked||!window.stack.isChecked()){setTimeout(()=>{if(!window.stack?.check||window.stack.check()===false){el.remove()}},100);return;}
if(!window.stack?.check||window.stack.check()===false){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--faq"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-faq-section')){
  class StackFAQSection extends HTMLElement {
    constructor() {
      super();
      this.resizeTimeout = null;
      this.initialized = false;
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const faqQuestions = this.querySelectorAll('.stack--faq-question');
      if (faqQuestions.length === 0) return;

      // Set initial heights
      this.setHeights();

      // Setup resize listener
      window.addEventListener('resize', this.boundHandleResize);

      // Setup click handlers
      faqQuestions.forEach(question => {
        question.addEventListener('click', this.handleQuestionClick.bind(this));
      });

      this.initialized = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.setHeights(), 200);
    }

    setHeights() {
      const answers = this.querySelectorAll('.stack--faq-answer');
      answers.forEach(answer => {
        const inner = answer.querySelector('.stack--faq-answer-inner');
        if (!inner) return;
        
        if (answer.getAttribute('aria-hidden') === 'false') {
          answer.style.height = inner.offsetHeight + 'px';
        } else {
          answer.style.height = '0px';
        }
      });
    }

    handleQuestionClick(event) {
      const question = event.currentTarget;
      const expanded = question.getAttribute('aria-expanded') === 'true';
      const answerId = question.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);
      if (!answer) return;
      
      const answerInner = answer.querySelector('.stack--faq-answer-inner');
      if (!answerInner) return;

      // Toggle current FAQ item
      question.setAttribute('aria-expanded', !expanded);
      answer.setAttribute('aria-hidden', expanded);

      // Smooth height animation
      if (expanded) {
        answer.style.height = '0px';
      } else {
        answer.style.height = answerInner.offsetHeight + 'px';
      }

      // Close other items (accordion behavior)
      if (!expanded) {
        const allQuestions = this.querySelectorAll('.stack--faq-question');
        allQuestions.forEach(otherQuestion => {
          if (otherQuestion !== question) {
            const otherAnswerId = otherQuestion.getAttribute('aria-controls');
            const otherAnswer = document.getElementById(otherAnswerId);
            if (!otherAnswer) return;

            otherQuestion.setAttribute('aria-expanded', 'false');
            otherAnswer.setAttribute('aria-hidden', 'true');
            otherAnswer.style.height = '0px';
          }
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.initialized = false;
    }
  }

  customElements.define('stack-faq-section', StackFAQSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--faq')) {
    const section = document.querySelector('.stack--faq');
    if (section && section.tagName.toLowerCase() === 'stack-faq-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--faq')) {
    const section = document.querySelector('.stack--faq');
    if (section && section.tagName.toLowerCase() === 'stack-faq-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--image-with-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--image-with-benefits');
if(!el)return;
if(!window.stack?.isChecked||!window.stack.isChecked()){setTimeout(()=>{if(!window.stack?.check||window.stack.check()===false){el.remove()}},100);return;}
if(!window.stack?.check||window.stack.check()===false){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--shoppable-slides"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-shoppable-slides-section')){
class StackShoppableSlidesSection extends HTMLElement {
constructor() {
super();
this.initialized = false;
this.swiper = null;
this.currentlyPlayingVideo = null;
}

connectedCallback() {
if(!window.stack?.isChecked||!window.stack.isChecked()){
setTimeout(()=>{
 if(!window.stack?.check||window.stack.check()===false){
   this.remove();
 } else {
   this.init();
 }
},100);
return;
}
if(!window.stack?.check||window.stack.check()===false){
this.remove();
return;
}
requestAnimationFrame(() => this.init());
}

init() {
if (this.initialized) return;

// Add initial load class for animation
if (this.classList.contains('stack--shoppable-slides-fade')) {
this.classList.add('stack--shoppable-slides-initial-load');
// Remove after animation completes
setTimeout(() => {
 this.classList.remove('stack--shoppable-slides-initial-load');
}, 1500);
}

this.initSwiperSlider();
this.initVideoControls();

this.initialized = true;
}

initSwiperSlider() {
const swiperContainer = this.querySelector('.stack--shoppable-slides-swiper');
if (!swiperContainer) return;

// Wait for Swiper library to load
if (typeof Swiper === 'undefined') {
setTimeout(() => this.initSwiperSlider(), 100);
return;
}

const autoplayEnabled = this.dataset.autoplay === 'true';
const coverflowEnabled = this.dataset.coverflow === 'true';
const swiperId = swiperContainer.id;

// Initialize Swiper configuration
const swiperConfig = {
grabCursor: true,
centeredSlides: true,
slidesPerView: 'auto',
spaceBetween: 20,
loop: true,
loopAddBlankSlides: true,
loopAdditionalSlides: 3,
speed: 600,

// Navigation (scoped to this specific swiper)
navigation: {
 nextEl: this.querySelector('.swiper-button-next'),
 prevEl: this.querySelector('.swiper-button-prev'),
},

// Autoplay (optional)
...(autoplayEnabled && {
 autoplay: {
   delay: 5000,
   disableOnInteraction: false,
   pauseOnMouseEnter: true,
 },
}),

// Coverflow effect (optional)
...(coverflowEnabled && {
 effect: 'coverflow',
 coverflowEffect: {
   rotate: 0,
   stretch: 0,
   depth: 85,
   modifier: 1,
   slideShadows: true,
 },
}),

// Accessibility
a11y: {
 enabled: true,
 prevSlideMessage: 'Previous video',
 nextSlideMessage: 'Next video',
 firstSlideMessage: 'This is the first video',
 lastSlideMessage: 'This is the last video',
},

// Keyboard control
keyboard: {
 enabled: true,
 onlyInViewport: true,
},

// Responsive breakpoints
breakpoints: {
 1024: {
   spaceBetween: 50,
 },
 768: {
  spaceBetween: 40,
 }
},

// Prevent animation on init
runCallbacksOnInit: false,

// On slide change, stop all videos
on: {
 slideChange: () => {
   this.stopAllVideos();
 },
},
};

// Initialize Swiper with unique ID
this.swiper = new Swiper(`#${swiperId}`, swiperConfig);
}

initVideoControls() {
const slides = this.querySelectorAll('.swiper-slide');

slides.forEach((slide) => {
 const video = slide.querySelector('.stack--shoppable-slides-video');
 const playButton = slide.querySelector('.stack--shoppable-slides-play-button');
 const playIcon = slide.querySelector('#iconPlay');
 const pauseIcon = slide.querySelector('#iconPause');

 if (!video || !playButton || !playIcon || !pauseIcon) return;

 // Play/Pause on button click
 playButton.addEventListener('click', (e) => {
   e.stopPropagation();
   
   // Only allow interaction on active, prev, or next slides
   if (
     slide.classList.contains('swiper-slide-active') ||
     slide.classList.contains('swiper-slide-next') ||
     slide.classList.contains('swiper-slide-prev')
   ) {
     // Stop other videos first
     if (this.currentlyPlayingVideo && this.currentlyPlayingVideo !== video) {
       this.stopVideo(this.currentlyPlayingVideo);
     }

     // Toggle current video
     if (video.paused) {
       video.volume = 0.4;
       video.play();
       playIcon.style.display = 'none';
       pauseIcon.style.display = 'block';
       playButton.setAttribute('aria-label', 'Pause video');
       this.currentlyPlayingVideo = video;
     } else {
       this.stopVideo(video);
     }
   }
 });

 // Reset video when it ends
 video.addEventListener('ended', () => {
   video.currentTime = 0;
   playIcon.style.display = 'block';
   pauseIcon.style.display = 'none';
   playButton.setAttribute('aria-label', 'Play video');
   if (this.currentlyPlayingVideo === video) {
     this.currentlyPlayingVideo = null;
   }
 });
});
}

stopVideo(video) {
if (!video) return;

const slide = video.closest('.swiper-slide');
if (!slide) return;

const playIcon = slide.querySelector('#iconPlay');
const pauseIcon = slide.querySelector('#iconPause');
const playButton = slide.querySelector('.stack--shoppable-slides-play-button');

video.pause();
if (playIcon) playIcon.style.display = 'block';
if (pauseIcon) pauseIcon.style.display = 'none';
if (playButton) playButton.setAttribute('aria-label', 'Play video');

if (this.currentlyPlayingVideo === video) {
 this.currentlyPlayingVideo = null;
}
}

stopAllVideos() {
const videos = this.querySelectorAll('.stack--shoppable-slides-video');
videos.forEach(video => this.stopVideo(video));
}

disconnectedCallback() {
// Cleanup Swiper instance
if (this.swiper && this.swiper.destroy) {
this.swiper.destroy(true, true);
}
this.stopAllVideos();
this.initialized = false;
}
}

customElements.define('stack-shoppable-slides-section', StackShoppableSlidesSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
setTimeout(() => section.init(), 100);
}
}
});

document.addEventListener('shopify:section:select', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
section.init();
}
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--stats-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-stats-benefits-section')){
  class StackStatsBenefitsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.observer = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const counters = this.querySelectorAll('.stack--stats-benefits-counter');
      const observerOptions = {
        threshold: 0.5,
        rootMargin: '0px 0px -50px 0px'
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.dataset.animated) {
            this.animateCounter(entry.target);
            entry.target.dataset.animated = 'true';
          }
        });
      }, observerOptions);

      counters.forEach(counter => {
        this.observer.observe(counter);
      });

      this.initialized = true;
    }

    animateCounter(counter) {
      const from = parseInt(counter.dataset.from) || 0;
      const to = parseInt(counter.dataset.to) || 0;
      const duration = parseInt(counter.dataset.duration) || 2000;
      
      if (from === to) return;
      
      const startTime = performance.now();
      const difference = to - from;
      
      const updateCounter = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(from + (difference * easeOut));
        
        counter.textContent = currentValue;
        
        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = to;
        }
      };
      
      requestAnimationFrame(updateCounter);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-stats-benefits-section', StackStatsBenefitsSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--stats-benefits')) {
      const section = document.querySelector('.stack--stats-benefits');
      if (section && section.tagName.toLowerCase() === 'stack-stats-benefits-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--testimonials"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-testimonials-section')){
  class StackTestimonialsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.swiper = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const layout = this.dataset.layout;
      
      if (layout === 'stack') {
        this.initStackViewMore();
      } else if (layout === 'slider') {
        this.initSwiperSlider();
      }

      this.initialized = true;
    }

    initStackViewMore() {
      const viewMoreBtn = this.querySelector('.stack--testimonials-view-more-btn');
      if (!viewMoreBtn) return;
      
      viewMoreBtn.addEventListener('click', () => {
        const hiddenCards = this.querySelectorAll('.stack--testimonials-card-hidden');
        hiddenCards.forEach(card => {
          card.classList.remove('stack--testimonials-card-hidden');
        });
        viewMoreBtn.parentElement.style.display = 'none';
      });
    }

    initSwiperSlider() {
      const swiperContainer = this.querySelector('.stack--testimonials-swiper');
      if (!swiperContainer) return;
      
      // Wait for Swiper library to load
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSwiperSlider(), 100);
        return;
      }
      
      // Initialize Swiper with configuration
      this.swiper = new Swiper('.stack--testimonials-swiper', {
        // Basic settings
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 600,
        // Navigation
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        centeredSlides: false,
        slidesPerView: 'auto',
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          firstSlideMessage: 'This is the first testimonial',
          lastSlideMessage: 'This is the last testimonial',
        },
        
        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        
        // Touch/Swipe
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        touchStartPreventDefault: false,
        
        // Effects
        effect: 'slide',
        fadeEffect: {
          crossFade: true,
        },
      });
    }

    disconnectedCallback() {
      // Cleanup Swiper instance
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-testimonials-section', StackTestimonialsSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();
})();
